import type { FaireProductEntity } from "../../entity_types/product";

export const p_3yyako6yt2: FaireProductEntity = {
  token: "p_3yyako6yt2",
  type: "product",
  name: "It's Always OK To Buy More Plants Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/282e76ff396f663e75e5320f3e9e0af970fd550324947f5d93baebd42eaafef3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c43192af1df1f3d4578b6355035745f0f59429561f68719b3e22cfa7e60a242f.jpeg",
    "https://cdn.faire.com/fastly/3f39c39515bde0826d592aa4d560f9899cedcda747a0f6c4ffef5f4942e41e97.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/ca6043908af2693e7656d21b44fbff5a49b5a9fa16cde14d825b2e2c3c1721dc.jpeg"
  ],
  priceDollars: 6.75,
  description: "If you ask us, there is no such thing as a room that couldn’t use another plant. Bathroom, bedroom, dungeon, kitchen or office! It’s Always Okay To Buy More Plants!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:28.326Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
